import { reatomAsync, withDataAtom } from "@reatom/async";
import { OrderInfoRequestWithUserIdDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getOrdersInfo = reatomAsync(
  async (ctx, data: OrderInfoRequestWithUserIdDto) => {
    return API.orderApi
      .orderControllerGetOrdersInfoByUserId(data)
      .then((response) => response.data);
  },
  "getOrdersInfoRequest",
).pipe(withDataAtom(null), withIsLoadingAtom());
